import { render, staticRenderFns } from "./SimExamPractice.vue?vue&type=template&id=1282fc68&scoped=true&"
import script from "./SimExamPractice.vue?vue&type=script&lang=js&"
export * from "./SimExamPractice.vue?vue&type=script&lang=js&"
import style0 from "./SimExamPractice.vue?vue&type=style&index=0&id=1282fc68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1282fc68",
  null
  
)

export default component.exports